export enum SettlementMethod {
  HOURLY = 'HOURLY',
  FLAT = 'FLAT',
}

export default SettlementMethod
